import gql from 'graphql-tag';
export default gql`
  mutation getSignedUrl($file: Upload, $shouldUpload: Boolean) {
    getSignedUrl(file: $file, shouldUpload: $shouldUpload) {
      uuid
      signedUrl
      fileName
      mimeType
    }
  }
`;
